(() => {
  const menus = document.querySelectorAll('[data-zen-mega-menu]');

  menus.forEach((menu) => {
    const categories = Array.from(menu.querySelectorAll('[data-zen-menu-category]'));

    if (!categories.length) {
      return;
    }

    const setActiveCategory = (activeCategory) => {
      categories.forEach((category) => {
        category.classList.toggle('is-active', category === activeCategory);
      });
    };

    menu.classList.add('zen-mega-clean__body--ready');
    setActiveCategory(categories[0]);

    categories.forEach((category) => {
      category.addEventListener('mouseenter', () => setActiveCategory(category));
      category.addEventListener('focusin', () => setActiveCategory(category));
    });

    const details = menu.closest('details');

    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open && !menu.querySelector('.zen-mega-clean__category.is-active')) {
          setActiveCategory(categories[0]);
        }
      });
    }
  });
})();
